import { Component, inject, input } from '@angular/core';
import { AufgabenTyp, AufgabeVersandTaetigkeit } from '@schir-int-client/aufgabe-shared';
import { CreateAufgabeFormService } from '../../create-aufgabe-dialog/create-aufgabe.formservice';

type AllowedAufgabenTyp =
	| AufgabenTyp.ABSCHRIFT_ZERTIFIKATSAUSZUG
	| AufgabenTyp.EIGENTUEMERBESCHEINIGUNG
	| AufgabenTyp.HYPOTHEKENBESCHEINIGUNG
	| AufgabenTyp.LOESCHUNGSBESCHEINIGUNG
	| AufgabenTyp.LASTENFREIHEITSBESCHEINIGUNG
	| AufgabenTyp.NAMENSAENDERUNGSBESCHEINIGUNG;

@Component({
	selector: 'schir-int-client-aufgabe-versand-editor',
	templateUrl: './aufgabe-versand-editor.component.html',
	styleUrls: ['./aufgabe-versand-editor.component.scss'],
	standalone: false,
})
export class AufgabeVersandEditorComponent {
	private readonly formService = inject(CreateAufgabeFormService);

	readonly aufgabenTyp = input.required<AllowedAufgabenTyp>();
	readonly excludeEingetragenerEigentuemer = input(true);

	readonly versandTaetigkeit = AufgabeVersandTaetigkeit;

	get formGroup() {
		return this.formService.form.controls[this.aufgabenTyp()];
	}

	get bodyControls() {
		return this.formGroup.controls.body.controls;
	}

	toggleFaxEmpfaengerControls(enable: boolean) {
		if (enable) {
			this.bodyControls['faxEmpfaenger']?.enable();
		} else {
			this.bodyControls['faxEmpfaenger']?.disable();
		}
	}

	protected readonly AufgabenTyp = AufgabenTyp;
}
